module.exports = __webpack_public_path__ + "img/oshad_logo.26c3bcad.png";